import {
  handleClearAudioNoteState,
  handleClearDetectedMeeting,
  handleDeleteAudioNote,
  handleGenerateSummaryForSavedNote,
  handleGetAudioNote,
  handleGetAudioNotes,
  handleGetAudioNotesWithinTimeWindow,
  handlePauseRecording,
  handleResumeRecording,
  handleStartRecording,
  handleStopRecording,
  handleUpdateAudioNote,
} from '../browser-audio-notes'
import type { BrowserFallbackRegistry } from './types'

export const audioNoteBrowserFallbacks: BrowserFallbackRegistry = {
  'audio-note': {
    getAudioNotes: () => handleGetAudioNotes(),
    getAudioNotesWithinTimeWindowDays: (payload) => handleGetAudioNotesWithinTimeWindow(payload),
    getAudioNote: (payload) => handleGetAudioNote(payload),
    updateAudioNote: (payload) => handleUpdateAudioNote(payload),
    deleteAudioNote: (payload) => handleDeleteAudioNote(payload),
    startRecording: (payload) => handleStartRecording(payload),
    stopRecording: (payload) => handleStopRecording(payload),
    pauseRecording: () => handlePauseRecording(),
    resumeRecording: () => handleResumeRecording(),
    clearAudioNoteState: () => handleClearAudioNoteState(),
    clearDetectedMeeting: () => handleClearDetectedMeeting(),
    generateSummaryForSavedNote: () => handleGenerateSummaryForSavedNote(),
    getAudioDebugInfo: () => ({
      appVersion: null,
      appChannel: null,
      platform: 'browser',
      runtime: null,
      status: 'idle',
      audioSessionId: null,
      activeNoteId: null,
      startTime: null,
      sessionLengthSeconds: null,
      transcriptCounts: { processed: 0, provider: 0, merged: 0 },
      meeting: null,
      recall: null,
      electronRuntime: null,
    }),
  },
}
